export default __webpack_public_path__ + "static/media/Whitemoon Chain.f29db844.jpg";